import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import { ACTIVE_COLOR } from '../../utils/constants';
import useThemeQuery from '../../graphql/queries/toggle-theme';

const useStyles = makeStyles(theme => ({
    root: {
        width: "stretch",
        display: "flex",
        flex: 1,
        marginRight: `${theme.spacing(3)}px`,
        fontSize: 16,
        textTransform: 'initial'
    },
    alignment: {
        display: "flex",
        flexDirection: "row"
    },
    selectedTabDark: {
        color: ACTIVE_COLOR,
    },
    selectedTabLight: {
        color: ACTIVE_COLOR,
        fontWeight: 600
    },
    tabDark: {
        color: '#6e7f9a'
    },
    tabLight: {
        color: '#A8B0C5',
    },
    img: {
        // width: 22,
        display: 'block',
        marginRight: 18
    },
    ajusteTypograph: {
        minWidth: 168,
    }
}));

const LinkTab = props => {
    const classes = useStyles();
    const { data } = useThemeQuery();

    const { router, value, iconLabel, location: { pathname }, minWidth=false } = props;
    const onClick = event => {
        event.preventDefault();
        router.push(value);
    }
    return (
        <Tab
            component="a"
            className={clsx(pathname === value ? data && data.theme ? classes.selectedTabDark: classes.selectedTabLight: data && data.theme ? classes.tabLight: classes.tabDark)}
            onClick={onClick}
            disableRipple
            icon={iconLabel && 
                <img 
                    alt={`icon-${iconLabel}`}
                    src={ pathname === value 
                        ?`${process.env.PUBLIC_URL}/icons/${iconLabel}-active.svg`
                        : `${process.env.PUBLIC_URL}/icons/${iconLabel}.svg`}
                    className={classes.img} 
                />
            }
            classes={{
                root: classes.root,
                wrapper: clsx(classes.alignment, minWidth && classes.ajusteTypograph)
            }}
            {...props}
        />
    );
}
export default LinkTab;